<template>
    <div class="common-layout">
        <el-container>
            <el-container style="height: 100vh;">
                <el-main class="main-wrapper">
                    <CandidateCartInternal v-show="mobileFilterState == false" :profiles="profiles"
                        @show="$refs.CheckoutProcessRef.showModal('StartModalInternal')" :is-mobile="isMobile"
                        :group-name="groupName" class="candidate-cart" />
                    <div class="content-wrapper">
                        <el-alert v-show="showSuccessAlert" title="Erfolg! Sie wurden erfolgreich angemeldet!"
                            type="success" show-icon :closable="true" @close="showSuccessAlert = false" />
                        <el-alert v-show="showAlert"
                            title="Das Limit von bis zu 10 Suchbegriffen wurde erreicht. Löschen Sie Suchbegriffe, um andere hinzufügen zu können."
                            type="info" show-icon :closable="false" />
                        <div class="searcher-wrapper">
                            <TabbedSearchBarInternal v-show="true" @searchResults="newSearch"
                                :main-filters="mainFilters"
                                @maxCompetencesLimitReached="handleMaxCompetencesLimitReached"
                                :group-name="groupName"  ref="tabbedSearchBarInternalRef"/>
                        </div>
                        <div class="results-wrapper" v-if="loaded" v-show="mode == 'results'">
                            <div class="content-wrapper profile-list-wrapper">
                                <input type="hidden" name="terms"
                                    :value="mainFilters.map((option) => option.name).join(', ')">
                                <div v-if="!debugMode">
                                    <div>
                                        <SearchResult :counter="filteredProfiles.length" :filters="mainFilters"
                                            :modifier="modifier" :removed-filters="removedFilters"
                                            @switchModifier="switchModifier" @removeFilter="removeFilter"
                                            @restoreFilter="restoreFilter" @updateSearch="updateSearch"
                                            @openSearcher="mode = 'searcher'" :results="profiles.length"
                                            @showSimiliarTags="showSimiliarTags"
                                            @resetSearchResult="handleResetSearchResult"
                                            @maxCompetencesLimitReached="handleMaxCompetencesLimitReached" />
                                    </div>
                                    <div>
                                    </div>

                                    <ProfileListInternal :profiles="profiles" :tmpProfiles="filteredProfiles" ref="profileList"
                                        :filters="structuredFilters" v-if="profiles.length > 0"
                                        :main-filters="mainFilters" />
                                </div>
                                <div v-else>
                                    <ProfileDebug :profiles="filteredProfiles" :selected-filters="selectedFilters"
                                        :filters="flattenFilters" />
                                </div>
                            </div>
                        </div>
                        <div v-if="profiles.length === 0" class="profile-placeholder-wrapper">
                            <ProfileListPlaceholder />
                        </div>
                        <div v-show="mode == 'error'">
                            {{ $trans('web_search.checkout_response_messages.simple_something_went_wrong') }}
                        </div>

                        <CheckoutProcessInternal ref="CheckoutProcessRef" :group-name="groupName" />
                    </div>
                </el-main>
            </el-container>
        </el-container>

        <el-dialog v-model="dialogTableVisible" title="Chose register option" width="800">
            <el-row :gutter="10">
                <el-col :span="24" class="register-link-wrapper">
                    <el-link class="client" :underline="false" href="https://matchmaker.de">Client</el-link>
                    <el-link class="pool-member" :underline="false"
                        href="https://matchmaker.deutscheinterim.com/register/check-email">Candidate</el-link>
                </el-col>
            </el-row>
        </el-dialog>
    </div>
</template>

<script>
import ActiveFilters from './Components/ActiveFilters';
import CandidateCartInternal from './Components/CandidateCartInternal';
import CheckoutProcessInternal from './Components/CheckoutProcessInternal';
import MobileFooter from './Components/MobileFooter';
import CloseModalButton from './Components/CheckoutProcess/CloseModalButton';
import Filters from './Components/Filters';
import ProfileListInternal from './Components/ProfileListInternal';
import ProfileDebug from './Components/ProfileDebug';
import SearcherBackdrop from './Components/SearcherBackdrop';
import SearchResult from './Components/SearchResult';
import SearchWithAi from './Components/SearchWithAi';
import ProfileListPlaceholder from './Components/ProfileListPlaceholder';
import Footer from './Components/Footer';
import TabbedSearchBarInternal from './Components/TabbedSearchBarInternal';

import { ref } from 'vue';
import { mapStores } from 'pinia';
import { useFilterOptionsStore } from '@/stores/FilterOptionsStore';
import { useSelectedFiltersStore } from '@/stores/SelectedFiltersStore';

export default {
    name: 'ResultsInternal',
    components: {
        ActiveFilters,
        CandidateCartInternal,
        CheckoutProcessInternal,
        CloseModalButton,
        Filters,
        ProfileListInternal,
        ProfileDebug,
        SearcherBackdrop,
        SearchResult,
        MobileFooter,
        SearchWithAi,
        ProfileListPlaceholder,
        TabbedSearchBarInternal,
        Footer
    },
    props: {
        groupName: String,
    },
    data() {
        return {
            loaded: false,
            profiles: [],
            mainFilters: [],
            removedFilters: [],
            selectedFilters: {},
            debugMode: false,
            modifier: undefined,
            mode: undefined,
            mobileFilterState: false,
            page: 1,
            showSuccessAlert: false,
            showAlert: false,
            isMobile: window.innerWidth <= 790,
            searchKindModifier: 'AI',
            urlObject: new URL(`${window.location.origin}/web-search/results/de`),
        };
    },
    created() {
    },
    mounted() {
        const url = new URL('/web-search/results/de', window.location.origin);
        this.debugMode = url.searchParams.has('debug') ? !!url.searchParams.get('debug') : false;
    },
    methods: {
        switchModifier(modifier) {
            const existingCompetences = this.urlObject.searchParams.get('competence')
                ?.split('-')
                .filter(Boolean) || [];
            const url = new URL('/web-search/results/de', window.location.origin);
            const combinedCompetences = Array.from(new Set([...existingCompetences]));
            this.urlObject.searchParams.set('competence', combinedCompetences.join('-'));

            url.searchParams.set('competence', combinedCompetences.join('-'));
            url.searchParams.set('modifier', modifier);

            this.fetchData(url);
        },
        newSearch(data) {
            this.mode = undefined;
            
            let fetchedCompetences = Array.isArray(data.competence)
                ? data.competence
                : (data.competence ? [data.competence] : []);
                
            let removedIds = this.removedFilters.map(f => String(f.id));

            let combined = [...new Set([...fetchedCompetences])]
                .filter(id => !removedIds.includes(String(id)))
                .slice(0, 10);
            
            const url = new URL('/web-search/results/de', window.location.origin);
            
            if (combined.length > 0) {
                this.urlObject.searchParams.set("competence", combined.join("-"));
                url.searchParams.set("competence", combined.join("-"));
            } else {
                this.urlObject.searchParams.delete("competence");
                url.searchParams.delete("competence");
            }

            if (data.job_tag) {
                this.urlObject.searchParams.set("job_tag", data.job_tag);
                url.searchParams.set("job_tag", data.job_tag);
            } else {
                this.urlObject.searchParams.delete("job_tag");
                url.searchParams.delete("job_tag");
            }

            this.urlObject.searchParams.set("modifier", data.modifier || "OR");
            url.searchParams.set("modifier", data.modifier || "OR");
        
            this.fetchData(url);
        },
        removeFilter(filter) {
            this.removedFilters.push(filter);
            this.mainFilters = this.mainFilters.filter(f => f.id !== filter.id);
        },
        restoreFilter(filter) {
            this.removedFilters = this.removedFilters.filter(f => f.id !== filter.id);
            this.mainFilters.push(filter);
        },
        updateSearch() {
            const url = new URL(this.urlObject.href);

            let activeCompetences = this.mainFilters
                .filter(f => f.type === 'competence')
                .map(f => f.id);
        
            if (activeCompetences.length > 0) {
                this.urlObject.searchParams.set('competence', activeCompetences.join('-'));
                url.searchParams.set('competence', activeCompetences.join('-'));
            } else {
                this.urlObject.searchParams.delete('competence');
                url.searchParams.delete('competence');
            }

            this.fetchData(url);
        },
        fetchData(url) {
            this.loaded = false;
            this.$functions.showLoader();

            url.searchParams.set('format', 'json');
            url.searchParams.set('internal', 'true');

            this.FilterOptionsStore.clearAllOptions();
            this.profiles = [];
            this.SelectedFiltersStore.registerFilters(Object.keys(this.flattenFilters));

            fetch(url.href)
                .then((res) => res.json())
                .then((json) => {
                    this.loaded = true;
                    this.$functions.hideLoader();

                    this.FilterOptionsStore.setProfiles(json.profiles);
                    this.FilterOptionsStore.setOptions('availabilityStatus', json.filters.availabilityStatus);
                    this.FilterOptionsStore.setOptions('competencies', json.filters.competencies);
                    this.FilterOptionsStore.setOptions('industrySectors', json.filters.industrySectors);
                    this.FilterOptionsStore.setOptions('regions', json.filters.regions);
                    this.FilterOptionsStore.setOptions('companySizes', json.filters.companySizes);
                    this.FilterOptionsStore.setOptions('educationLevels', json.filters.educationLevels);
                    this.FilterOptionsStore.setOptions('languages', json.filters.languages);

                    this.profiles = json.profiles;

                    let fetchedFilters = json.main_filters;
                    if (this.removedFilters && this.removedFilters.length > 0) {
                        const removedIds = this.removedFilters.map(rf => rf.id);
                        fetchedFilters = fetchedFilters.filter(f => !removedIds.includes(f.id));
                    }
                    this.mainFilters = fetchedFilters;

                    this.mainFilters = this.connectWithColorCodes();
                    this.modifier = json.modifier;

                    this.callChildMethod();
                })
                .catch((error) => {
                    console.log(error);
                    this.mode = 'error';
                    this.$functions.hideLoader();
                })
                .finally(() => {
                    this.SelectedFiltersStore.registerFilters(Object.keys(this.flattenFilters));
                    if (this.mainFilters.length) {
                        this.mode = 'results';
                    } else {
                        this.mode = 'searcher';
                    }
                    this.loaded = true;
                    this.$functions.hideLoader();
                });
        },
        callChildMethod() {
            const childComponent = this.$refs.profileList;

            if (childComponent) {
                childComponent.resetPage();
            }
        },
        setSearchKind(kind) {
            if (this.searchKindModifier !== kind) {
                this.searchKindModifier = kind;
            }
        },
        handleShowSuccessLoginAlert() {
            this.showSuccessAlert = true;
            setTimeout(() => {
                this.showSuccessAlert = false;
            }, 5000);
            this.$functions.hideLoader();
            return;
        },
        updateIsMobile() {
            this.isMobile = window.innerWidth <= 790;
        },
        switcherBackground() {
            return {
                background:
                    this.searchKindModifier === 'AI'
                        ? 'linear-gradient(90deg, #a06dd6, #9e6ed6, #8f7ad1, #8682cf, #8385ce, #7e89cd, #7a8dcc, #7690ca, #7294c9, #6d9ac7, #6d9ac7, #699fc6, #68a0c6, #67a2c5)'
                        : '#41abc4',
            };
        },
        toggleSearchKind() {
            this.searchKindModifier =
                this.searchKindModifier === 'AI' ? 'KEYWORD' : 'AI';
            this.fetchSearchResults();
        },
        resetState() {
            this.profiles = [];
            this.loaded = false;
            this.mainFilters = [];
            this.removedFilters = [];
            this.selectedFilters = {};
            this.debugMode = false;
            this.modifier = "OR";
            this.mode = undefined;
            this.mobileFilterState = false;
            this.page = 1;
            this.isOpen = false;
            this.showContent = false;
            this.searchKindModifier = 'AI';
        },
        handleResetSearchResult() {
            this.profiles = [];
            this.loaded = false;
            this.mainFilters = [];
            this.removedFilters = [];
            this.selectedFilters = {};
            this.debugMode = false;
            this.modifier = "OR";
            this.mode = undefined;
            this.mobileFilterState = false;
            this.page = 1;
            this.isOpen = false;
            this.showContent = false;
            this.searchKindModifier = 'AI';

            let searchInput = document.getElementById('search-input');
            if (searchInput) {
                searchInput.value = '';
                searchInput.style.height = '15px';
            }

            this.urlObject.searchParams.delete('competence');
            this.$refs?.tabbedSearchBarInternalRef?.$refs?.searcherRef?.resetHierarchy();
        },
        connectWithColorCodes() {
            const colors = [
                "#999b77", "#809877", "#6b958a", "#6d97a5",
                "#7180a8", "#8c7caa", "#aa7c98", "#bc7575", "#b49a77",
                "#8a8f9a"
            ];

            let assignedColors = {};

            return this.mainFilters.map((filter, index) => {
                if (index < colors.length) {
                    assignedColors[filter.id] = colors[index];
                } else {
                    const randomColor = colors[Math.floor(Math.random() * colors.length)];
                    assignedColors[filter.id] = randomColor;
                }
                return { ...filter, color: assignedColors[filter.id] };
            });
        },
        handleSearchResults() {

        },
    },
    computed: {
        ...mapStores(useFilterOptionsStore),
        ...mapStores(useSelectedFiltersStore),
        structuredFilters() {
            let filters = this.FilterOptionsStore.getAllOptions();
            const sortByOccurrences = (options, profiles, key) => {
                return options
                    .filter(option => option && option.id != null)
                    .map((option) => {
                        const count = profiles.filter((profile) => {
                            switch (key) {
                                case 'competencies':
                                    return profile.filter_competencies.includes(Number(option.id));
                                case 'industrySectors':
                                    return profile.filter_industry_sectors.includes(Number(option.id));
                                case 'regions':
                                    return profile.filter_regions.includes(option.id);
                                case 'languages':
                                    return profile.filter_languages.includes(option.id);
                                case 'educationLevels':
                                    return profile.filter_education.includes(Number(option.id));
                                case 'companySizes':
                                    return profile.filter_company_sizes.includes(Number(option.id));
                                case 'availabilityStatus':
                                    return profile.availability_status == option.id;
                                default:
                                    return false;
                            }
                        }).length;

                        return { ...option, occurrences: count };
                    })
                    .sort((a, b) => {
                        if (b.occurrences !== a.occurrences) {
                            return b.occurrences - a.occurrences;
                        }
                        if (a.name && b.name) {
                            return a.name.localeCompare(b.name);
                        }
                        return 0;
                    });
            };

            let structuredFilters = {
                competencies: {
                    title: this.$trans("web_search.filter_names.qualifications"),
                    options: sortByOccurrences(filters.competencies, this.profiles, "competencies"),
                    searchbar: true,
                    modifierSwitch: true,
                    hidden: filters.competencies.length == 0,
                },
                industrySectors: {
                    title: this.$trans("web_search.filter_names.industry_sectors"),
                    options: sortByOccurrences(filters.industrySectors, this.profiles, "industrySectors"),
                    hidden: filters.industrySectors.length == 0,
                },
                availabilityStatus: {
                    title: this.$trans("web_search.filter_names.availability"),
                    options: filters.availabilityStatus,
                    modifierState: "OR",
                    hidden: filters.availabilityStatus.length == 0,
                },
                regions: {
                    title: this.$trans("web_search.filter_names.regions"),
                    filters: filters.regions,
                    hidden: filters.regions.length == 0,
                },
                companySizes: {
                    title: this.$trans("web_search.filter_names.company_size"),
                    options: filters.companySizes,
                    hidden: filters.companySizes.length == 0,
                    maxLength: -1,
                },
                educationLevels: {
                    title: this.$trans("web_search.filter_names.education"),
                    filters: filters.educationLevels,
                    hidden: filters.educationLevels.length == 0,
                },
                languages: {
                    title: this.$trans("web_search.filter_names.languages"),
                    filters: filters.languages,
                    hidden: filters.languages.length == 0,
                },
            };

            return structuredFilters;
        },

        flattenFilters() {
            return this.FilterOptionsStore.getAllFlattenOptions();
        },
        filteredProfiles() {
            let activeFilters = this.SelectedFiltersStore.getActiveFilters();
            let modifiers = this.SelectedFiltersStore.getModifiers();
            this.callChildMethod();

            if (this.SelectedFiltersStore.getActiveFiltersCount() == 0) {
                return this.profiles;
            }

            let tmpProfiles = this.profiles;

            return tmpProfiles
                .filter((profile) => {
                    if (activeFilters.availabilityStatus.length == 0) {
                        return true;
                    }

                    if (Object.hasOwn(modifiers, 'availabilityStatus') && modifiers.availabilityStatus == 'OR') {
                        return activeFilters.availabilityStatus.some((optionId) => {
                            return profile.availability_status == optionId;
                        });
                    }

                    return activeFilters.availabilityStatus.every((optionId) => {
                        return profile.availability_status == optionId;
                    });
                })
                .filter((profile) => {
                    if (activeFilters.competencies.length == 0) {
                        return true;
                    }
                    if (Object.hasOwn(modifiers, 'competencies') && modifiers.competencies == 'OR') {
                        return activeFilters.competencies.some((optionId) => {
                            return profile.filter_competencies.includes(parseInt(optionId));
                        });
                    }

                    return activeFilters.competencies.every((optionId) => {
                        return profile.filter_competencies.includes(parseInt(optionId));
                    });
                })
                .filter((profile) => {
                    if (activeFilters.industrySectors.length == 0) {
                        return true;
                    }

                    if (Object.hasOwn(modifiers, 'industrySectors') && modifiers.industrySectors == 'OR') {
                        return activeFilters.industrySectors.some((optionId) => {
                            return profile.filter_industry_sectors.includes(parseInt(optionId));
                        });
                    }

                    return activeFilters.industrySectors.every((optionId) => {
                        return profile.filter_industry_sectors.includes(parseInt(optionId));
                    });
                })
                .filter((profile) => {
                    if (activeFilters.regions.length == 0) {
                        return true;
                    }

                    if (Object.hasOwn(modifiers, 'regions') && modifiers.regions == 'OR') {
                        return activeFilters.regions.some((optionId) => {
                            return profile.filter_regions.includes(optionId);
                        });
                    }

                    return activeFilters.regions.every((optionId) => {
                        return profile.filter_regions.includes(optionId);
                    });
                })
                .filter((profile) => {
                    if (activeFilters.languages.length == 0) {
                        return true;
                    }

                    if (Object.hasOwn(modifiers, 'languages') && modifiers.languages == 'OR') {
                        return activeFilters.languages.some((optionId) => {
                            return profile.filter_languages.includes(optionId);
                        });
                    }

                    return activeFilters.languages.every((optionId) => {
                        return profile.filter_languages.includes(optionId);
                    });
                })
                .filter((profile) => {
                    if (activeFilters.educationLevels.length == 0) {
                        return true;
                    }

                    if (Object.hasOwn(modifiers, 'educationLevels') && modifiers.educationLevels == 'OR') {
                        return activeFilters.educationLevels.some((optionId) => {
                            return profile.filter_education.includes(parseInt(optionId));
                        });
                    }

                    return activeFilters.educationLevels.every((optionId) => {
                        return profile.filter_education.includes(optionId);
                    });
                })
                .filter((profile) => {
                    if (activeFilters.companySizes.length == 0) {
                        return true;
                    }

                    if (Object.hasOwn(modifiers, 'companySizes') && modifiers.companySizes == 'OR') {
                        return activeFilters.companySizes.some((optionId) => {
                            return profile.filter_company_sizes.includes(parseInt(optionId));
                        });
                    }

                    return activeFilters.companySizes.every((optionId) => {
                        return profile.filter_company_sizes.includes(optionId);
                    });
                });
        },
        currentUrl() {
            return window.location.origin;
        }
    },
}
</script>

<style scoped>
@import url('https:/fonts.googleapis.com/css2?family=Barlow:ital,wght@0,100;0,200;0,300;0,400;0,500;0,600;0,700;0,800;0,900;1,100;1,200;1,300;1,400;1,500;1,600;1,700;1,800;1,900&display=swap');
@import url('https://fonts.googleapis.com/css2?family=Inter:ital,opsz,wght@0,14..32,100..900;1,14..32,100..900&display=swap');

.clslm-1 {
    fill: #303030;
    font-family: Barlow-Medium, Barlow;
    font-size: 26px;
    font-weight: 500;
}

.results-wrapper {
    display: flex;
    align-items: flex-start;
}

.error-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 50px;
    padding: 50px;
}

.side-wrapper {
    background-color: white;
    width: 320px;
    margin: 50px 0;
    box-sizing: border-box;
    padding: 15px;
    border-top-right-radius: 8px;
    border-bottom-right-radius: 8px;
}

.content-wrapper {
    position: relative;
    padding: 15px;
    width: calc(100vw - 320px);
    box-sizing: border-box;
}

@media only screen and (max-width: 790px) {
    .results-wrapper {
        display: block;
        margin-bottom: 64px;
    }

    .side-wrapper {
        display: none;
        position: fixed;
        z-index: 100;
        left: 0;
        right: 0;
        top: 0;
        bottom: 0;
        border-radius: 8px;
        width: calc(100% - 30px);
        margin: 15px;
        box-sizing: border-box;
        overflow-y: scroll;
    }

    .side-wrapper.show {
        display: block;
    }

    .content-wrapper {
        max-width: unset;
        width: 100%;
    }

    .header-wrapper {
        margin-left: 33% !important;
        margin-top: 60px;
        margin-bottom: 30px;
    }
}

/* new styles */
* {
    font-family: Barlow;
}

.common-layout {
    background-color: #EBEBEB !important;
}

.header-wrapper {
    margin-top: 30px;
    margin-bottom: 30px;
    margin-left: -21px !important;
}

.start-wrapper {
    text-align: center;
    place-items: center;
    place-content: center;
}

.chatbot-wrapper {
    width: 50%;
    text-align: center;
    place-items: center;
    place-content: center;
    overflow: hidden;
    display: flex;
    flex-wrap: nowrap;
    flex-direction: column;
    margin-top: 60px;
    min-height: calc(100vh - 200px);
}

.messages-wrapper {
    border-bottom: 1px solid #DDDDDD;
    width: 100%;
    padding-top: 30px;
    padding-bottom: 30px;
    text-align: left !important;
    display: flex;
    flex-direction: row;
}

.main-title {
    margin-bottom: 50px;
    font: normal normal 600 42px/50px Cormorant Garamond;
    letter-spacing: -1.26px;
    color: #4D5255;
}

.subtitle {
    margin-bottom: 15px;
    letter-spacing: -0.36px;
    color: #3C3C3C;
    font: normal normal normal 1rem/1.75rem Inter;
}

.logo {
    width: 115px;
}

.chat-bot-wrapper {
    width: 800px;
}

.input-wrapper {
    display: flex;
    justify-content: center;
    align-items: center;
    width: 100%;
}

.input-wrapper-row {
    width: 100%;
    margin-top: auto;
}

.search-btn {
    background-color: #fff;
    float: right;
    width: 60px;
    height: 60px;
    border-radius: 50%;
    border: 0px;
    padding: 0px;
    cursor: pointer;
}

.arrow-image {
    width: 60px;
    height: 60px;
    padding: 0px;
    transform: rotate(270deg);
    filter: invert(80%) sepia(0%) saturate(43%) hue-rotate(141deg) brightness(98%) contrast(101%);
}

.arrow-image:hover {
    filter: invert(70%) sepia(81%) saturate(549%) hue-rotate(158deg) brightness(81%) contrast(88%);
}

.question-input {
    border: 0px;
    background-color: #f5f5f5 !important;
    width: 100%;
    float: left;
    font-size: 18px;

}

.question-input:focus {
    outline: none;
}

.input-group {
    border: 1px solid #c7c7c7;
    background-color: #F5F5F5 !important;
    border-radius: 20px;
    width: 100%;
    font-size: 18px;
    padding: 10px;
    align-items: center;
    display: flex;
    justify-content: space-between;
    margin-top: 30px;
}

.loader {
    font-size: 24px;
    float: right;
    padding: 10px;
    margin: 10px;
    border: 0px !important;
    width: 100% !important;
}

.main-wrapper {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
}

.footer-wrapper {
    padding-top: 25px;
    font-size: 15px;
    letter-spacing: -0.3px;
    color: #3C3C3C;
    font-family: Inter !important;
}

.footer-wrapper a {
    color: #3C3C3C;
    font-family: Inter !important;
}

.link {
    color: #3C3C3C;
    text-decoration: none;
}

.dot {
    height: 5px;
    width: 5px;
    background-color: #41ABC4;
    border-radius: 50%;
    display: inline-block;
}

.user-wrapper {
    text-align: center;
}

.avatar {
    width: 70px;
    height: 70px;
    border-radius: 50%;
}

.chat-wrapper {
    width: 100%;
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    overflow: scroll;
}

.message-avatar .avatar {
    width: 36px;
    height: 36px;
    border-radius: 50%;
}

.message-content {
    padding-left: 15px !important;
    text-align: left;
    font: normal normal normal 18px/32px Inter;
    letter-spacing: -0.36px;
    color: #3C3C3C;
}

.loader {
    color: #b5b5b5;
    width: 4px !important;
    padding: 0 !important;
    align-items: center;
    aspect-ratio: 1;
    border-radius: 50%;
    box-shadow: 19px 0 0 7px, 38px 0 0 3px, 57px 0 0 0;
    transform: translateX(-38px);
    animation: l21 .5s infinite alternate linear;
}


@keyframes l21 {
    50% {
        box-shadow: 19px 0 0 3px, 38px 0 0 7px, 57px 0 0 3px
    }

    100% {
        box-shadow: 19px 0 0 0, 38px 0 0 3px, 57px 0 0 7px
    }
}

.message-content-loader {
    display: flex;
    flex-direction: column;
    flex-wrap: nowrap;
    justify-content: center;
    align-items: center;
    text-align: center;
}

.loading {
    border: 0 !important;
}

.beta {
    height: 40px;
    width: 100px;
    background-color: #EA975A;
    border-radius: 24px;
    text-align: center;
    margin-left: 20px;
    top: -15px;
    position: absolute;
    color: #fff;
    font-size: 26px;
    font-family: Barlow;
    letter-spacing: 0.31px;
}


.pool-member {
    height: 200px;
    width: 200px;
    font-size: 26px;
    font-family: Inter;
    border-radius: 20px;
    border: 1px solid #b5b5b5;
}

.client {
    height: 200px;
    width: 200px;
    font-size: 26px;
    font-family: Inter;
    border-radius: 20px;
    border: 1px solid #b5b5b5;
}

.pool-member:hover {
    border-color: #B465D8;
    color: #B465D8
}

.client:hover {
    border-color: #B465D8;
    color: #B465D8
}

.di-link {
    text-decoration: underline;
}

.menu-links a {
    color: #fff;
    display: block;
    font-size: 18px;
    padding-bottom: 3px;
}

a.login-link {
    color: #fff;
    display: block;
    font-size: 18px;
    font-size: 18px;
    padding-bottom: 3px;
    top: -72px;
    left: 62px;
    text-decoration: none;
    color: white;
    margin-bottom: 20px;
    text-decoration: none;
}

a.login-link:hover::after {
    display: none;
}

.common-layout,
.el-container,
.el-header,
.el-main,
.el-aside {
    width: 100%;
    margin: 0;
}

body {
    margin: 0;
}

.main-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
    height: 100%;
}

.searcher-wrapper {
    z-index: 10;
    margin: 0 auto;
    width: 79%;
}

.results-wrapper {
    display: flex;
    flex-direction: column;
    justify-content: flex-start;
}

.side-wrapper {
    width: 250px;
    margin-right: 20px;
    transition: transform 0.3s ease-in-out;
    display: flex;
    flex-direction: column;
}

.content-wrapper {
    flex-grow: 1;
    background-color: #ededed;
    margin-top: 32px;
}

.side-wrapper.show {
    transform: translateX(0);
}

.side-wrapper {
    transform: translateX(-100%);
}

.wrapper {
    margin-left: 10%;
}

.searcher-wrapper {
    display: flex;
    flex-direction: column;
    gap: 20px;
}

.switcher-container {
    display: flex;
    align-items: center;
    justify-content: center;
}

.switcher {
    display: flex;
    align-items: center;
    gap: 10px;
}

.toggle-description {
    font-size: 1rem;
    color: #000;
    font-style: italic;
    cursor: pointer;
    transition: color 0.3s ease, transform 0.3s ease, opacity 0.3s ease;
    opacity: 0.8;
}

.toggle-description.selected {
    border-bottom: 1px solid #000;
    opacity: 1;
    transform: scale(1.1);
}

.toggle {
    width: 40px;
    height: 20px;
    background: #ddd;
    border-radius: 10px;
    position: relative;
    cursor: pointer;
    transition: background 0.3s ease;
}

.toggle:hover {
    background: #bbb;
}

.toggle-handle {
    width: 18px;
    height: 18px;
    background: #ffffff;
    border-radius: 50%;
    position: absolute;
    top: 1px;
    left: 1px;
    transition: left 0.3s ease, background 0.3s ease;
}

.toggle-handle.right {
    left: 21px;
}

.start-wrapper {
    text-align: center;
    place-items: center;
    place-content: center;
    display: grid;
    justify-content: center;
}

.search-description-wrapper {
    padding-top: 25px;
    color: #252525;
}

.main-title {
    font: italic normal 500 36px/46px Cormorant Garamond;
    letter-spacing: -1.26px;
    color: #4D5255;
}

.subtitle {
    letter-spacing: -0.36px;
    color: #3C3C3C;
    font: normal normal normal 1rem/1.75rem Inter;
}

.subtitle>span {
    font: normal normal normal 600 18px/32px Inter;
}

.el-header {
    position: sticky;
    top: 0;
    z-index: 1000;
    height: 160px;
    border-bottom: 1px solid #BCBAB6;
    margin: 0 auto;
    width: 65%;
}

.el-main {
    flex: 1;
    overflow-y: auto;
    height: calc(107vh - 60px);
    padding: unset !important;
    overflow-x: hidden;
}

.common-layout {
    height: 100vh;
    display: flex;
    flex-direction: column;
}

.matchmaker {
    align-self: flex-start;
    padding-left: 10px;
    font-weight: bold;
    color: white;
}

.register-description {
    margin: 10px 15px;
    color: white;
}

.register-description button {
    background-color: white;
    color: #3C3C3C;
    border: none;
    padding: 10px 15px;
    border-radius: 5px;
    cursor: pointer;
    display: block;
    margin: 10px auto 0;
    width: 100%;
}

.menu-links a {
    color: white;
    text-decoration: none;
    padding: 5px 0;
}

.menu-links a:last-child {
    padding-bottom: 10px;
    margin-bottom: 10px;
}

.menu-links {
    display: flex;
    flex-direction: column;
    width: 100%;
    border-bottom: 1px solid white;
    margin: 10px 15px;
    color: white;
    width: 90%;
}

.app-name {
    margin-left: 5%;
    color: #fff;
}

.header-text {
    display: flex;
    position: absolute;
    right: 142px;
    top: 96px;
    left: 35%;
    font: normal normal normal 21px/25px Barlow;
}

.logo-wrapper {
    display: flex;
    align-items: center;
}

.header-company-name {
    fill: #303030;
    font-family: Barlow-Medium, Barlow;
    font-size: 26px;
    font-weight: 500;
    margin-top: 34px;
}

.logo-link {
    display: flex;
    align-items: center;
    text-decoration: none;
    color: inherit;
}

.logo-swiss {
    width: 200px;
    margin-bottom: 10px;
    margin-top: 34px;
}

.logo-matchmaker {
    width: 300px;
    margin-bottom: 13px;
    margin-top: 67px;
}

.candidate-cart {
    position: absolute;
    right: 364px;
    top: 130px;
}

@media (max-width: 768px) {
    .icons-wrapper {
        display: block !important;
    }

    .el-header {
        padding: 5px;
        height: 115px;
    }

    .switcher-container {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .register-link-wrapper {
        display: flex;
        flex-direction: column;
        align-items: center;
    }

    .register-link-wrapper .el-link {
        margin-bottom: 10px;
    }

    .searcher-wrapper {
        margin-bottom: -7px;
    }
}

.change-search-kind-enter-active {
    transition: transform 0.6s ease-out, opacity 0.6s ease-in-out;
}

.change-search-kind-enter-from,
.change-search-kind-leave-to {
    transform: translateY(-30px) scale(0.96);
    opacity: 0;
}

@media (max-width: 768px) {
    .header-wrapper {
        margin-left: 30% !important;
        margin-top: -17px;
        margin-bottom: 40px;
    }

    .icons-wrapper {
        display: block !important;
    }

    .logo {
        width: 100px;
    }

    .beta {
        height: 22px;
        width: 60px;
        top: -20px;
        position: absolute;
        font-size: 14px;
        margin-left: -116px;
    }

    .register-link {
        right: 8vw !important;
    }

    .main-title {
        font: normal normal 600 25px/38px Cormorant Garamond;
        margin-bottom: 15px;
    }

    .subtitle {
        font: normal normal normal 12px/28px Inter;
    }

    .sidebar {
        display: none;
    }

    .chatbot-wrapper {
        width: 100% !important;
        margin-top: 0;
    }

    .message-content {
        padding-left: 34px !important;
    }

    .main-title {
        font: italic normal 500 22px/31px Cormorant Garamond;
    }

    .el-main {
        --el-main-padding: 0px;
    }
}

@media (max-width: 1900px) {
    .message-content {
        padding-left: 20px !important;
    }
}

@media (max-width: 1200px) {
    .message-content {
        padding-left: 35px !important;
    }
}
</style>
